var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lazy-video", class: _vm.bemFacets }, [
    _vm.hasMqInformation && _vm.isMobile
      ? _c("img", {
          staticClass: "lazy-video--element",
          attrs: { alt: "", src: _vm.fallback }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.hasMqInformation && !_vm.isMobile
      ? _c(
          "video",
          {
            staticClass: "lazy-video--element",
            attrs: {
              autoplay: "",
              muted: "",
              playsinline: "",
              poster: _vm.poster,
              loop: _vm.loop ? true : null
            },
            domProps: { muted: true }
          },
          [
            _vm.webmSrc
              ? _c("source", {
                  attrs: { type: "video/webm", src: _vm.webmSrc }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.mp4Src
              ? _c("source", { attrs: { type: "video/mp4", src: _vm.mp4Src } })
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68e66d8a", { render: render, staticRenderFns: staticRenderFns })
  }
}